<template>
  <div class="group-listing manage-listing">
    <div class="mb-12">
      <v-row>
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-compact font-weight-bold mb-12 align-center"
          >
            Manage Group
          </v-card-title>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="group.members"
            :items-per-page="5"
            class="border-radius-0 v-data-table-2 v-data-table-2--style"
          >
            <template v-slot:item.check_in="{}">
              {{ group.check_in }}
            </template>
            <template v-slot:item.check_out="{}">
              {{ group.check_out }}
            </template>
            <template v-slot:item.country_code="{ value }">
              {{ getCountry(value).name }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-row class="d-flex fill-height align-center">
                <v-col>
                  <v-icon @click="editMember(item)">
                    $edit
                  </v-icon>
                  <v-icon
                    v-if="item.id !== group.lead.id"
                    @click="
                      item.id !== group.lead.id ? removeMember(item.id) : ''
                    "
                  >
                    $deleteAlert
                  </v-icon>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <transition name="slide-fade">
        <v-row v-if="!newMemberMode">
          <v-col>
            <v-card-actions class="mt-10 px-5 flex-column flex-md-row">
              <v-btn
                depressed
                large
                color="black"
                class="white--text px-5 px-md-14 mr-md-8 justify-space-between justify-md-center"
                @click="newMember()"
              >
                New Member
                <v-icon class="ml-10" right>
                  $plus
                </v-icon>
              </v-btn>
              <v-btn
                depressed
                large
                min-width="275px"
                class="ml-0 px-5 px-md-14 px-14 primary"
                @click="goToList()"
              >
                Finish
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <GroupMember
              :group="group"
              :member="selectedMember"
              @done="newMemberAdded"
            />
          </v-col>
        </v-row>
      </transition>
    </div>
  </div>
</template>

<script>
import Model from '@models/Group';
import { getCountry } from '@services/Countries';

export default {
  name: 'GroupMembers',
  metaInfo: {
    titleTemplate: '%s - Group Members',
  },
  components: {
    GroupMember: () => import('./_partials/GroupMember'),
  },
  data() {
    return {
      newMemberMode: false,
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Last Name', value: 'last_name' },
        { text: 'Country of Origin', value: 'country_code' },
        { text: 'Check in', value: 'check_in', sortable: false },
        { text: 'Check out', value: 'check_out', sortable: false },
        { text: 'Email', value: 'email' },
        { text: 'Action', value: 'action', sortable: false },
      ],
      selectedMember: {},
      group: {
        members: [],
      },
      model: new Model(),
    };
  },
  methods: {
    getCountry,
    newMember() {
      this.selectedMember = {};
      this.newMemberMode = true;
    },
    async editMember(member) {
      this.newMemberMode = false;
      await this.$nextTick();
      this.selectedMember = this.clone(member);
      this.newMemberMode = true;
    },
    newMemberAdded(member) {
      if (member && this.selectedMember.id) {
        let memberIndex = this.group.members.findIndex(
          (m) => m.id === this.selectedMember.id && m.id === member.id
        );
        if (memberIndex > -1) {
          Object.assign(this.group.members[memberIndex], member);
        }
      } else if (member) {
        this.group.members.splice(0, 0, member);
      }

      this.selectedMember = {};
      this.newMemberMode = false;
    },
    async removeMember(memberID) {
      if (
        await $question(
          'Are you sure you want to remove this member from this group?'
        )
      ) {
        let response = await this.model.removeMember(memberID);
        if (response) {
          $showSuccess(response.message, 'delete-group-members');
          this.group.members = this.group.members.filter(
            (member) => member.id !== memberID
          );
        }
      }
    },
    goToList() {
      if (this.$route.from && this.$route.from.name === 'groups') {
        this.$route.back();
        return;
      }
      this.$router.push({
        name: 'groups',
      });
    },
    cancel() {
      this.newMemberMode = false;
    },
  },
  async mounted() {
    let id = this.$route.params.id;
    this.model.addRelation('members');
    let response = await this.model.findById(id);
    if (response) {
      let group = response.data;
      this.group = Object.assign(this.group, group);
    }
  },
};
</script>
